import dayjs from 'dayjs';
import { useState } from 'react';
import { DELETED_SANITIZED_CASES_CSV } from 'src/api';
import axios from 'src/axios';
import { handleErrorToast } from 'src/components/molecules/Toast';
import { downloadFile } from 'src/utils/commonFunctions';
import { DateFormats, formatDate, getNow } from 'src/utils/time';
import { getStartDateForPreset, PresetKey } from '../utils';

export const useExportLog = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedPreset, setSelectedPreset] = useState<PresetKey>('last30d');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setDrawerOpen(false);
    setSelectedPreset('last30d');
    setFromDate('');
    setToDate('');
  };

  const handleGenerate = async () => {
    const params: Record<string, string> =
      fromDate && toDate
        ? {
            startDate: dayjs(fromDate).startOf('day').toISOString(),
            endDate: dayjs(toDate).endOf('day').toISOString(),
          }
        : { startDate: getStartDateForPreset(selectedPreset) };

    const timestamp = formatDate(
      getNow({ returnAsDate: true }),
      DateFormats.YYYY_MM_DD_HH_MM,
    );

    setLoading(true);
    try {
      const response = await axios.get(DELETED_SANITIZED_CASES_CSV, { params });
      downloadFile(
        new Blob([response.data]),
        `DeletedSanitizedLog-${timestamp}.csv`,
      );
      handleClose();
    } catch {
      handleErrorToast({
        toastMessage: 'Export failed',
        toastDescription:
          "Sorry, we couldn't generate the log. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  const isGenerateDisabled =
    loading || (!fromDate && !!toDate) || (!!fromDate && !toDate);

  return {
    drawerOpen,
    setDrawerOpen,
    selectedPreset,
    setSelectedPreset,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    loading,
    handleClose,
    handleGenerate,
    isGenerateDisabled,
  };
};
